import { render, staticRenderFns } from "./CollegeLoginRegister.vue?vue&type=template&id=a89eefc8&scoped=true&"
import script from "./CollegeLoginRegister.vue?vue&type=script&lang=js&"
export * from "./CollegeLoginRegister.vue?vue&type=script&lang=js&"
import style0 from "./CollegeLoginRegister.vue?vue&type=style&index=0&id=a89eefc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89eefc8",
  null
  
)

export default component.exports